import { createRouter, createWebHistory } from 'vue-router'
import {
  authRoutes,
  dashRoutes,
  errorRoutes,
  inventoryRoutes,
  objectRoutes,
  schedulesRoutes,
  usersRoutes,
} from './list'
import { useAuth } from '@/entities/Auth'
import { rememberInventoryRouteObjectId } from '@/shared/lib'
import { usePagePreloader } from '@/shared/ui'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...authRoutes,
    ...dashRoutes,
    ...objectRoutes,
    ...usersRoutes,
    ...schedulesRoutes,
    ...errorRoutes,
    ...inventoryRoutes,
  ],
})

/**
 * Переадресация, ТОЛЬКО для Ленсвета, никуда не переносить
 */
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    return next('/objects/groups/55974/inventory/elements')
  }

  next()
})

/**
 * Сохраняем навигацию при совпадении типов объекта
 */
router.beforeEach((to, from, next) => {
  if (
    from.params.type &&
    from.params.object_id !== to.params.object_id &&
    from.params.type === to.params.type
  ) {
    const newRoute = {
      name: from.name,
      params: { ...from.params, object_id: to.params.object_id },
    }

    if (newRoute.name !== to.name || newRoute.params.object_id !== to.params.object_id) {
      next(newRoute)
    } else {
      next()
    }
  } else {
    next()
  }
})

/**
 * Проверяем авторизованность пользователя
 */
router.beforeEach((to, from, next) => {
  const { setVisible } = usePagePreloader()
  setVisible(true)

  const auth = useAuth()

  if (to.meta.protected && !auth.token) {
    auth.deleteToken()
    auth.deleteAuth()

    router.push('/auth/login')
  }

  next()
})

router.afterEach((to) => {
  const oid = to.params.object_id
  if (typeof oid === 'string' && /^\d+$/.test(oid)) rememberInventoryRouteObjectId(oid)

  const { setVisible } = usePagePreloader()
  setVisible(false)
})

export default router
